import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentCombine from "core/Components/ContentCombine";

type Props = {
    data: ContentWithImage,
    className?: string,
    isUsingAltDesign: boolean,
};

const Description: React.FC<Props> = ({ data, className, isUsingAltDesign }) => {
    const theme: Theme = useTheme();

    const colourTheme = JSON.parse(data.theme);
    const { textColour, anchorColour } = colourTheme;

    const contentTextStyle = css`
        margin-bottom: 40px;

        ${textColour && css`
            color: ${textColour};
        `}

        ${isUsingAltDesign && css`
            font-family: ${theme.fonts.openSans};
            font-weight: ${theme.fonts.weights.light};
            font-size: 19px;
            line-height: 35px;
            
            ul {
                margin-top: 14px;
            }
        `};


        ${isUsingAltDesign && theme.breakpoints.up("5xl")} {
            margin-bottom: ${isUsingAltDesign ? "33px" : "20px" };
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            margin-bottom: ${isUsingAltDesign ? "22px" : "20px" };
        }

        ${theme.breakpoints.only("xl")} {
            margin-bottom: ${isUsingAltDesign ? "22px" : "50px"};
        }

        ${theme.breakpoints.down('lg')} {
            font-size: 14px;
            line-height: ${isUsingAltDesign ? "28px": "20px"};
        }
        
        ${theme.breakpoints.only("lg")} {
            margin-bottom: 26px;
        }

        ${theme.breakpoints.only("md")} {
            margin-bottom: 24px;
        }

        ${theme.breakpoints.down("sm")} {
            margin-bottom: ${isUsingAltDesign ? "19px" : "22px"};
        }
    `;

    return (
        <ContentCombine
            Tag={"p"}
            fontSizeType={"9"}
            css={contentTextStyle}
            className={className}
            anchorColour={anchorColour}
        >
            {data.text}
        </ContentCombine>
    );
};

export default Description;
